import React from 'react';
import { PatternFormat } from 'react-number-format';

const FacturaInput = props => {
  const { inputRef, onChange, ...other } = props;

  return (
    <PatternFormat
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.formattedValue
          }
        });
      }}
      format="###-###-#######"
      allowEmptyFormatting
      mask="_"
      {...other}
    />
  );
};

export default FacturaInput;
